export { namespace } from './actions';
import { Status, ActionType } from './actions';

const initialState = {
  status: Status.INITIAL,
  data: []
}

export default function locationGranularityReducer(state = initialState, action) {
  
  switch (action.type) {
    case ActionType.SET_LOCATION_GRANULARITY:
      {
        const { locationGranularity } = action.payload;
        return {
          ...state,
          status: Status.LOADED,
          data: [...locationGranularity]
        }
      }
    default:
      return state;
  }
}
